import * as ng from 'angular';

ng.module('e360')
   .factory('$exceptionHandler', errorHandlerFactory);

errorHandlerFactory.$inject = ['$log'];
export function errorHandlerFactory($log:ng.ILogService) {
   return errorHandler;
   function errorHandler(exception, cause) {
      $log.error(exception);
      let enableBugSnag = localStorage.getItem('ls.enableBugSnag');
      if (enableBugSnag == "true") {
         if (exception instanceof Error) {
            Bugsnag.notifyException(exception);
         } else {
            Bugsnag.notify('Unhandled error', exception);
         }
      }
   }
}
